import { render, staticRenderFns } from "./Model.vue?vue&type=template&id=b38a3154&scoped=true&"
import script from "./Model.vue?vue&type=script&lang=js&"
export * from "./Model.vue?vue&type=script&lang=js&"
import style0 from "./Model.vue?vue&type=style&index=0&id=b38a3154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38a3154",
  null
  
)

export default component.exports